// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function summary_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "is_portergold_active",
                Decco.boolToJson(v.is_portergold_active)
              ],
              [
                "mobile",
                Decco.stringToJson(v.mobile)
              ],
              [
                "address",
                Decco.optionToJson(Decco.stringToJson, v.address)
              ],
              [
                "city",
                Decco.optionToJson(Decco.stringToJson, v.city)
              ],
              [
                "uuid",
                Decco.stringToJson(v.uuid)
              ]
            ]);
}

function field_encode(v) {
  return Js_dict.fromArray([
              [
                "attribute_name",
                Decco.stringToJson(v.attribute_name)
              ],
              [
                "attribute_value",
                Decco.optionToJson(Decco.stringToJson, v.attribute_value)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "summary",
                summary_encode(v.summary)
              ],
              [
                "first_name",
                field_encode(v.first_name)
              ],
              [
                "last_name",
                field_encode(v.last_name)
              ],
              [
                "caller_type",
                field_encode(v.caller_type)
              ],
              [
                "mobile",
                field_encode(v.mobile)
              ],
              [
                "secondary_mobile",
                field_encode(v.secondary_mobile)
              ],
              [
                "port_gold_status",
                field_encode(v.port_gold_status)
              ],
              [
                "geo_region",
                field_encode(v.geo_region)
              ],
              [
                "email",
                field_encode(v.email)
              ],
              [
                "unconfirmed_email",
                field_encode(v.unconfirmed_email)
              ],
              [
                "customer_type",
                field_encode(v.customer_type)
              ],
              [
                "temporarily_deactivated",
                field_encode(v.temporarily_deactivated)
              ],
              [
                "blacklist_reason",
                field_encode(v.blacklist_reason)
              ],
              [
                "registration_status",
                field_encode(v.registration_status)
              ],
              [
                "partload_customer",
                field_encode(v.partload_customer)
              ],
              [
                "subscribed_for_promo_sms",
                field_encode(v.subscribed_for_promo_sms)
              ]
            ]);
}

export {
  summary_encode ,
  field_encode ,
  t_encode ,
  
}
/* No side effect */
